export const mapMarketName = (marketConfig, dict, sportId) => {
    return [
        dict[`${sportId}_${marketConfig.idLive}`]
            || dict[`${sportId}_${marketConfig.idPreLive}`]
            || dict[marketConfig.idLive]
            || dict[marketConfig.idPreLive]
            || marketConfig.idLive
    ];
};
//# sourceMappingURL=mapMarketName.js.map